import React from "react";
import CommunityTemplateBlock from "./communityTemplatesBlock";
import { FormattedMessage } from "react-intl";
import "../style.css";

const CommunityTemplatesList = ({templatesToShow, auth, accountantUuidSelected}) => {
  return (
    <>
      <div className="communityTemplatesBlockContainer">
		  {templatesToShow.length > 0 ?
		    templatesToShow.map((templ, index) => {
		      return (
		        <CommunityTemplateBlock
		          index={index}
				  key={`community_${index}`}
		          templateName={templ.name}
		          templateCategory={templ.category}
		          templateAuthor={templ.authorName}
		          templateDate={templ.insertTimestamp}
		          templateScore={templ.score}
		          templatePrice={templ.price}
		          templateDownloads={templ.downloadNumber}
		          templateId={templ.templateId}
		        />
		      );
		    })
		    : <div><FormattedMessage id="ask.pages.edit.communityTemplates.emptyList"/></div>
		  }
      </div>
    </>
  );
};

export default CommunityTemplatesList;